// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-media-container {
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  max-width: 800px;
  margin: 2rem auto;
  overflow: hidden;
}

.social-media-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 0.5rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  animation: fadeInDown 0.8s ease-out;
}

.social-media-subtitle {
  font-size: 1rem;
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
  animation: fadeInUp 0.8s ease-out;
}

.social-media-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.5rem;
}

.social-media-item {
  display: flex;
  align-items: center;
  padding: 1rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  width: 280px;
  position: relative;
  overflow: hidden;
  animation: fadeIn 0.5s ease-out;
}

.social-media-item:nth-child(1) {
  animation-delay: 0.1s;
}

.social-media-item:nth-child(2) {
  animation-delay: 0.2s;
}

.social-media-item:hover, .social-media-item.hovered {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.social-media-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(45deg, rgba(255,255,255,0.1), rgba(255,255,255,0.5));
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.social-media-item:hover::before, .social-media-item.hovered::before {
  transform: translateX(100%);
}

.social-media-icon-container {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}

.social-media-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.social-media-item:hover .social-media-icon, .social-media-item.hovered .social-media-icon {
  transform: scale(1.1);
}

.social-media-info {
  flex-grow: 1;
}

.social-media-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.25rem 0;
  transition: color 0.3s ease;
}

.social-media-link {
  font-size: 0.8rem;
  color: #888;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.social-media-item:hover .social-media-name, .social-media-item.hovered .social-media-name {
  color: #007bff;
}

/* Facebook specific styling */
.social-media-item[key="Facebook"] .social-media-icon-container,
.social-media-item:has(.social-media-name:contains("Facebook")) .social-media-icon-container {
  background-color: #f0f2ff;
}

/* TikTok specific styling */
.social-media-item[key="Tik tok"] .social-media-icon-container,
.social-media-item:has(.social-media-name:contains("Tik tok")) .social-media-icon-container {
  background-color: #ffeef2;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .social-media-container {
    padding: 1.5rem;
  }
  
  .social-media-links {
    flex-direction: column;
    align-items: center;
  }
  
  .social-media-item {
    width: 100%;
    max-width: 320px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SocialMedia/SocialMediaLinks.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gFAAgF;EAChF,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;;EAEE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;;EAEE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".social-media-container {\n  padding: 2rem;\n  background-color: #f8f9fa;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);\n  max-width: 800px;\n  margin: 2rem auto;\n  overflow: hidden;\n}\n\n.social-media-title {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 0.5rem;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  animation: fadeInDown 0.8s ease-out;\n}\n\n.social-media-subtitle {\n  font-size: 1rem;\n  color: #666;\n  text-align: center;\n  margin-bottom: 2rem;\n  animation: fadeInUp 0.8s ease-out;\n}\n\n.social-media-links {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 1.5rem;\n}\n\n.social-media-item {\n  display: flex;\n  align-items: center;\n  padding: 1rem;\n  background-color: white;\n  border-radius: 10px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  cursor: pointer;\n  width: 280px;\n  position: relative;\n  overflow: hidden;\n  animation: fadeIn 0.5s ease-out;\n}\n\n.social-media-item:nth-child(1) {\n  animation-delay: 0.1s;\n}\n\n.social-media-item:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.social-media-item:hover, .social-media-item.hovered {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n}\n\n.social-media-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(45deg, rgba(255,255,255,0.1), rgba(255,255,255,0.5));\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n.social-media-item:hover::before, .social-media-item.hovered::before {\n  transform: translateX(100%);\n}\n\n.social-media-icon-container {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 1rem;\n  border-radius: 50%;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.social-media-icon {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n}\n\n.social-media-item:hover .social-media-icon, .social-media-item.hovered .social-media-icon {\n  transform: scale(1.1);\n}\n\n.social-media-info {\n  flex-grow: 1;\n}\n\n.social-media-name {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 0.25rem 0;\n  transition: color 0.3s ease;\n}\n\n.social-media-link {\n  font-size: 0.8rem;\n  color: #888;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.social-media-item:hover .social-media-name, .social-media-item.hovered .social-media-name {\n  color: #007bff;\n}\n\n/* Facebook specific styling */\n.social-media-item[key=\"Facebook\"] .social-media-icon-container,\n.social-media-item:has(.social-media-name:contains(\"Facebook\")) .social-media-icon-container {\n  background-color: #f0f2ff;\n}\n\n/* TikTok specific styling */\n.social-media-item[key=\"Tik tok\"] .social-media-icon-container,\n.social-media-item:has(.social-media-name:contains(\"Tik tok\")) .social-media-icon-container {\n  background-color: #ffeef2;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .social-media-container {\n    padding: 1.5rem;\n  }\n  \n  .social-media-links {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .social-media-item {\n    width: 100%;\n    max-width: 320px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
